import request from '@/utils/request'

export function get() {
  return request({
    url: '/sys-config/get',
    method: 'get',
  })
}
export function update(data) {
  return request({
    url: '/sys-config/update',
    method: 'post',
    type: "json",
    data
  })
}
export function costPackingList() {
  return request({
    url: '/sys-config/cost-packing/list',
    method: 'get',
  })
}

export function costSourcingDel(data) {
  return request({
    url: '/sys-config/cost-sourcing/del',
    method: 'post',
    data
  })
}
export function costSourcingAdd(data) {
  return request({
    url: '/sys-config/cost-sourcing/add',
    method: 'post',
    type: "json",
    data
  })
}
export function costSourcingEdit(data) {
  return request({
    url: '/sys-config/cost-sourcing/edit',
    method: 'post',
    type: "json",
    data
  })
}

export function costSourcingList() {
  return request({
    url: '/sys-config/cost-sourcing/list',
    method: 'get',
  })
}

export function costPackingDel(data) {
  return request({
    url: '/sys-config/cost-packing/del',
    method: 'post',
    data
  })
}
export function costPackingEdit(data) {
  return request({
    url: '/sys-config/cost-packing/edit',
    method: 'post',
    type: "json",
    data
  })
}
export function costPackingAdd(data) {
  return request({
    url: '/sys-config/cost-packing/add',
    method: 'post',
    type: "json",
    data
  })
}